import Vue from 'vue';
import i18n from "@/i18n";
import store from "@/store";
// import vuetify from './plugins/vuetify';

function shopName() {
  return store.state.settings && store.state.settings.shop_custom_name
    ? store.state.settings.shop_custom_name
    : i18n.t("Shop.default_shop_name");
}
function setShopName(str) {
  return i18n.t(str, [shopName()])
}
Vue.filter('setShopName', setShopName);

function allianceName() {
  return store.state.settings && store.state.settings.agent_custom_name
    ? store.state.settings.agent_custom_name
    : i18n.t("Alliances.default_alliance_name");
}
function setAllianceName(str) {
  return i18n.t(str, [allianceName()])
}
Vue.filter('setAllianceName', setAllianceName);
function maxValue(){
  return 99999999;
}
function setMaxValue(num) {
  return i18n.t(num, [maxValue()])
}
Vue.filter('setMaxValue', setMaxValue);

var outStatus = [
  {
    text: i18n.t("StockOuts.outStatus.wait_approval"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("StockOuts.outStatus.wait_out"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("StockOuts.outStatus.complete"),
    color: "primary",
    textColor: "white",
    value: 3
  },
]
function outStatusItem(value) {
  var item = outStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function outStatusText(value) {
  return outStatusItem(value).text;
}
Vue.filter('outStatusText', outStatusText);
function outStatusColor(value) {
  return outStatusItem(value).color;
}
Vue.filter('outStatusColor', outStatusColor);
function outStatusTextColor(value) {
  return outStatusItem(value).textColor;
}
Vue.filter('outStatusTextColor', outStatusTextColor);



var cancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "grey",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 0
  }
];
// 查找cancelFlgs
function cancelFlgsItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return cancelFlgs.find((element) => element.value == value);
}
function cancelFlgsText(value) {
  return cancelFlgsItem(value).text;
}
Vue.filter('cancelFlgsText', cancelFlgsText);
function cancelFlgsColor(value) {
  return cancelFlgsItem(value).color;
}
Vue.filter('cancelFlgsColor', cancelFlgsColor);
function cancelFlgsTextColor(value) {
  return cancelFlgsItem(value).textColor;
}
Vue.filter('cancelFlgsTextColor', cancelFlgsTextColor);

// 发货单来源
var origin_flgs = [
  {
    text: i18n.t("Delivery.originFlgs.purchase"),
    value: "101",
  },
  {
    text: i18n.t("Delivery.originFlgs.order_purchase"),
    value: "102",
  },
  {
    text: i18n.t("Delivery.originFlgs.smart"),
    value: "103",
  },
  {
    text: i18n.t("Delivery.originFlgs.default_import"),
    value: "201",
  },
  // {
  //   text: i18n.t("Delivery.originFlgs.donkey"),
  //   value: "202",
  // },
  {
    text: i18n.t("Delivery.originFlgs.norm"),
    value: "301",
  },
]
function originFlgsItem(value) {
  var item = origin_flgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Delivery.originFlgs.purchase"),
    color: "gray",
    textColor: "white",
    value: "101",
  };
}
function originFlgsText(value) {
  return originFlgsItem(value).text;
}
Vue.filter('originFlgsText', originFlgsText);
function originFlgsColor() {
  return "";
}
Vue.filter('originFlgsColor', originFlgsColor);
function originFlgsTextColor() {
  return "";
}
Vue.filter('originFlgsTextColor', originFlgsTextColor);

// 发货单来源
var supplierExamineStatus = [
  {
    text: i18n.t("Delivery.supplierExamineStatus.distributed"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Delivery.supplierExamineStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
]


function getDayStart() {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  return from;
}
function getDayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}
var checkFlgs = [
  {
    text: i18n.t("Delivery.checkStatus.off"),
    color: "grey",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("Delivery.checkStatus.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]
function checkFlgsItem(value) {
  var item = checkFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function checkFlgsText(value) {
  return checkFlgsItem(value).text;
}
Vue.filter('checkFlgsText', checkFlgsText);
function checkFlgsColor(value) {
  return checkFlgsItem(value).color;
}
Vue.filter('checkFlgsColor', checkFlgsColor);
function checkFlgsTextColor(value) {
  return checkFlgsItem(value).textColor;
}
Vue.filter('checkFlgsTextColor', checkFlgsTextColor);


// 供应商网页deliver发货状态
var deliverFlgs = [
  {
    text: i18n.t("Delivery.Status.off"),
    color: "grey",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("Delivery.Status.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]
function deliverFlgsItem(value) {
  var item = deliverFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function deliverFlgsText(value) {
  return deliverFlgsItem(value).text;
}
Vue.filter('deliverFlgsText', deliverFlgsText);
function deliverFlgsColor(value) {
  return deliverFlgsItem(value).color;
}
Vue.filter('deliverFlgsColor', deliverFlgsColor);
function deliverFlgsTextColor(value) {
  return deliverFlgsItem(value).textColor;
}
Vue.filter('deliverFlgsTextColor', deliverFlgsTextColor);

// 对账单类型（采购对账单，采购退货对账单）
var purchaseBillTypes = [
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchase"),
    color: "primary",
    textColor: "white",
    value: 201,
  },
  {
    text: i18n.t("ReceiptBillAnalyze.billTypes.billTypePurchaseReturn"),
    color: "primary",
    textColor: "white",
    value: 202,
  }
]
// 发货状态
var purchaseDeliverFlgs = [
  {
    text: i18n.t("MaterialAnalyze.deliveryFlgs.off"),
    color: "grey",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("MaterialAnalyze.deliveryFlgs.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]
// 统计类型
var statisticalType = [
  {
    text: i18n.t("MaterialAnalyze.statisticalType.direct_store"),
    color: "grey",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("MaterialAnalyze.statisticalType.brand"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]
// 定价单状态
var economiesFlgs = [
  {
    text: i18n.t("Economies.status.wait_economy"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("Economies.status.complete_economy"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("Economies.status.complete"),
    color: "primary",
    textColor: "white",
    value: 3
  }
]
function economiesFlgsItem(value) {
  var item = economiesFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function economiesFlgsText(value) {
  return economiesFlgsItem(value).text;
}
Vue.filter('economiesFlgsText', economiesFlgsText);
function economiesFlgsColor(value) {
  return economiesFlgsItem(value).color;
}
Vue.filter('economiesFlgsColor', economiesFlgsColor);
function economiesFlgsTextColor(value) {
  return economiesFlgsItem(value).textColor;
}
Vue.filter('economiesFlgsTextColor', economiesFlgsTextColor);


// 报价单状态
var questionFlgs = [
  {
    text: i18n.t("Question.status.wait_confirm"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("Question.status.wait_examine"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("Question.status.wait_complete"),
    color: "primary",
    textColor: "white",
    value: 3
  },
]
function questionFlgsItem(value) {
  var item = questionFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function questionFlgsText(value) {
  return questionFlgsItem(value).text;
}
Vue.filter('questionFlgsText', questionFlgsText);
function questionFlgsColor(value) {
  return questionFlgsItem(value).color;
}
Vue.filter('questionFlgsColor', questionFlgsColor);
function questionFlgsTextColor(value) {
  return questionFlgsItem(value).textColor;
}
Vue.filter('questionFlgsTextColor', questionFlgsTextColor);
// 是否采用
var useFlgs = [
  {
    text: i18n.t("Question.questionDetail.useFlg.on"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("Question.questionDetail.useFlg.off"),
    color: "danger",
    textColor: "white",
    value: 0
  }
]
function useFlgsItem(value) {
  var item = useFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}function useFlgsText(value) {
  return useFlgsItem(value).text;
}
Vue.filter('useFlgsText', useFlgsText);
function useFlgsColor(value) {
  return useFlgsItem(value).color;
}
Vue.filter('useFlgsColor', useFlgsColor);
function useFlgsTextColor(value) {
  return useFlgsItem(value).textColor;
}
Vue.filter('useFlgsTextColor', useFlgsTextColor);


// 是否有疑义
var questionDoubtFlgs = [
  {
    text: i18n.t("Question.questionDoubtFlg.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("Question.questionDoubtFlg.off"),
    color: "primary",
    textColor: "white",
    value: 1
  },
]
function questionDoubtFlgsItem(value) {
  var item = questionDoubtFlgs.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function questionDoubtFlgsText(value) {
  return questionDoubtFlgsItem(value).text;
}
Vue.filter('questionDoubtFlgsText', questionDoubtFlgsText);
function questionDoubtFlgsColor(value) {
  return questionDoubtFlgsItem(value).color;
}
Vue.filter('questionDoubtFlgsColor', questionDoubtFlgsColor);
function questionDoubtFlgsTextColor(value) {
  return questionDoubtFlgsItem(value).textColor;
}
Vue.filter('questionDoubtFlgsTextColor', questionDoubtFlgsTextColor);

var cloudPrinterMaxStr = [
  {
    text: i18n.t("cloudPrinterSetting.settings.58mm"),
    color: "primary",
    textColor: "white",
    value: 32,
  },
  {
    text: i18n.t("cloudPrinterSetting.settings.80mm"),
    color: "primary",
    textColor: "white",
    value: 48,
  },
];

function cloudPrinterMaxStrItem(value) {
  var item = cloudPrinterMaxStr.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}

function cloudPrinterMaxStrText(value) {
  return cloudPrinterMaxStrItem(value).text;
}
Vue.filter('cloudPrinterMaxStrText', cloudPrinterMaxStrText);

// 采购一览状态
var purchaseStatus = [
  {
    text: i18n.t("Delivery.status.new"),
    color: "primary",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("Delivery.status.wait"),
    color: "primary",
    textColor: "white",
    value: 2
  },
  {
    text: i18n.t("Delivery.status.part"),
    color: "primary",
    textColor: "white",
    value: 3
  },
  {
    text: i18n.t("Delivery.status.complete"),
    color: "primary",
    textColor: "white",
    value: 4
  },
  {
    text: i18n.t("Delivery.status.cancel"),
    color: "danger",
    textColor: "white",
    value: 99
  },
]
// 查找status
function purchaseStatusItem(value) {
  var item = purchaseStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function purchaseStatusText(value) {
  return purchaseStatusItem(value).text;
}
Vue.filter('purchaseStatusText', purchaseStatusText);
function purchaseStatusColor(value) {
  return purchaseStatusItem(value).color;
}
Vue.filter('purchaseStatusColor', purchaseStatusColor)
function purchaseStatusTextColor(value) {
  return purchaseStatusItem(value).textColor;
}
Vue.filter('purchaseStatusTextColor', purchaseStatusTextColor)

var examineStatus = [
  {
    text: i18n.t("Delivery.examineStatus.distributed"),
    color: "primary",
    textColor: "white",
    value: 0,
  },
  {
    text: i18n.t("Delivery.examineStatus.finished"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
];
// 查找Examine Status
function examineStatusItem(value) {
  var item = examineStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "primary",
    textColor: "white",
    value: "",
  };
}
function examineStatusText(value) {
  return examineStatusItem(value).text;
}
Vue.filter('examineStatusText', examineStatusText);
function examineStatusColor(value) {
  return examineStatusItem(value).color;
}
Vue.filter('examineStatusColor', examineStatusColor);
function examineStatusTextColor(value) {
  return examineStatusItem(value).textColor;
}
Vue.filter('examineStatusTextColor', examineStatusTextColor);
// 新建采购 缺货状态
var isLackStatus = [
  {
    text: i18n.t("PurchasesList.status.off"),
    color: "danger",
    textColor: "white",
    value: 1
  },
  {
    text: i18n.t("PurchasesList.status.on"),
    color: "primary",
    textColor: "white",
    value: 0
  },
]
function isLackStatusItem(value) {
  var item = isLackStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function isLackStatusText(value) {
  return isLackStatusItem(value).text;
}
Vue.filter('isLackStatusText', isLackStatusText);
function isLackStatusColor(value) {
  return isLackStatusItem(value).color;
}
Vue.filter('isLackStatusColor', isLackStatusColor)
function isLackStatusTextColor(value) {
  return isLackStatusItem(value).textColor;
}
Vue.filter('isLackStatusTextColor', isLackStatusTextColor)

export default {
  shopName,
  allianceName,
  maxValue,
  limitAll: 10000000,
  cancelFlgs,
  deliverFlgs,
  checkFlgs,
  origin_flgs,
  supplierExamineStatus,
  purchaseBillTypes,
  purchaseDeliverFlgs,
  purchaseStatus,
  statisticalType,
  questionFlgs,
  questionDoubtFlgs,
  economiesFlgs,
  useFlgs,
  outStatus,
  cloudPrinterMaxStr,
  dateTimeRangeShortcuts: [
    {
      text: i18n.t("$datetime.shortcuts.today"),
      onClick: () => {
        return [getDayStart(), getDayEnd()];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.yesterday"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 6);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(from.getMonth() - 1);
        from.setDate(from.getDate() + 1);
        return [from, end];
      },
    },
    // {
    //   text: i18n.t("$datetime.shortcuts.inHalfYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setMonth(from.getMonth() - 6);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    // {
    //   text: i18n.t("$datetime.shortcuts.inOneYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setFullYear(from.getFullYear() - 1);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    {
      text: i18n.t("$datetime.shortcuts.thisWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
           day = 7
         }
        from.setDate(from.getDate() - day + 1);
        end.setDate(end.getDate() + 7 - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
          day = 7
        }
        from.setDate(from.getDate() - 6 - day);
        end.setDate(end.getDate() - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        from.setMonth(from.getMonth() - 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        from.setFullYear(from.getFullYear() - 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
  ],
}